<template>
  <span
    role="alert"
    aria-live="assertive"
  >
    <svgicon
      name="Misc/Loading-red-animated"
      class="loading"
      :style="{width: `${_size}rem`, height: `${_size}rem`}"
    />
    <p class="loading__visually-hidden" />
  </span>
</template>

<script>
import svgIcon from "vue-svgicon"
import "#/Misc/Loading-red-animated"

export default {
  name: "LegacySpinner",
  components: {
    svgicon: svgIcon
  },
  props: {
    size: {
      type: Number,
      default: 4
    },
  },
}
</script>

<style lang="scss" scoped>
.loading {
  fill: $color-red;
  width: 4rem;
  height: 4rem;
}
</style>
